import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, XIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { CHECKOUT_URL, PRICE, ANCHOR_PRICE } from '../lib/config';
const rows: {
  without: string;
  with: string;
}[] = [{
  without: 'Improvisas cada consulta y esperas tener suerte',
  with: 'Sigues un sistema probado, mensaje por mensaje'
}, {
  without: 'Cobras precio de amiga y trabajas el doble',
  with: 'Cobras como profesional y entregas como agencia'
}, {
  without: 'Empiezas de cero con cada pareja',
  with: 'Abres el tomo. Copias el guion. Listo.'
}];
export function Close() {
  return <section className="w-full bg-ink py-20 sm:py-28" data-id="element-46" data-mp="179a7hhof7tg1">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-47" data-mp="176nq6qbq9zkm">
        <h2 className="font-serif text-3xl leading-snug sm:text-[2.9rem] sm:leading-tight text-ivory" data-id="element-48" data-mp="128m5y22kfu7k">
          Ya te dijeron tres veces que deberías dedicarte a esto. Lo que te falta no es
          permiso: <span className="italic text-gold" data-id="element-49" data-mp="3vedm8ywmslj5">es el sistema.</span>
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-50" data-mp="4199l8byswqv" />
        <p className="mx-auto mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-ivory/70" data-id="element-51" data-mp="42k8ouugtgbn">
          Únete a las planners que dejaron de improvisar: con guion para cada conversación,
          precio que sostienen sin culpa, y una agenda que se llena por recomendación en vez
          de por cuota mensual.
        </p>
        <p className="mx-auto mt-8 max-w-2xl text-[11px] uppercase tracking-[0.24em] text-gold" data-id="element-52" data-mp="n050a9om6szy">
          Posicionamiento · WhatsApp · Anti-ghosting · Recomendación · Finanzas · Meta Ads —
          todo resuelto
        </p>

        <div className="mt-14 overflow-hidden border border-gold/30 text-left" data-id="element-53" data-mp="d04d2cnmjsqh">
          <div className="grid grid-cols-1 sm:grid-cols-2" data-id="element-54" data-mp="2ssac3lbzetp4">
            <div className="border-b border-gold/25 px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-ivory/50 sm:border-r" data-id="element-55" data-mp="2suwi3gj85158">
              Sin el OS
            </div>
            <div className="hidden border-b border-gold/25 px-6 py-4 text-[11px] uppercase tracking-[0.2em] text-gold sm:block" data-id="element-56" data-mp="1484km4a51q05">
              Con el OS
            </div>
          </div>
          {rows.map((row, index) => <div key={row.with} className={`grid grid-cols-1 sm:grid-cols-2 ${index > 0 ? 'border-t border-gold/20' : ''}`} data-id="element-57" data-mp="ugrv3jbtbbxa" data-mpi={index}>
              <p className="flex items-start gap-3 px-6 py-5 text-[15px] text-ivory/55 sm:border-r sm:border-gold/20" data-id="element-58" data-mp="kilud51qsbu0">
                <XIcon className="mt-1 h-4 w-4 shrink-0 text-ivory/35" aria-hidden="true" data-id="element-59" data-mp="bk0g3m3aziz1" />
                {row.without}
              </p>
              <p className="flex items-start gap-3 px-6 py-5 text-[15px] text-ivory" data-id="element-60" data-mp="6mgw05jxcbz6">
                <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-61" data-mp="25x8chi6xg2ms" />
                {row.with}
              </p>
            </div>)}
        </div>

        <p className="mt-16 text-[11px] uppercase tracking-[0.3em] text-gold" data-id="element-62" data-mp="28j92x8mgnt9j">
          El precio de lanzamiento termina en
        </p>
        <div className="mt-7" data-id="element-63" data-mp="2dg7vhmqh7s5m">
          <Countdown tone="dark" data-id="element-64" data-mp="2dfg0oe4pdyge" />
        </div>

        <p className="mt-10 font-serif text-xl text-ivory" data-id="element-65" data-mp="2i9k8t0ppgcj2">
          Wedding Pro OS™ — 6 Tomos + 5 Bonos
        </p>
        <p className="mt-3 flex items-end justify-center gap-3" data-id="element-66" data-mp="2n72javjdezt6">
          <s className="font-serif text-2xl text-ivory/40" data-id="element-67" data-mp="1pkn1fsn18053">{ANCHOR_PRICE}</s>
          <span className="font-serif text-5xl leading-none text-gold" data-id="element-68" data-mp="1uiohe4p5vjcc">{PRICE}</span>
        </p>

        <div className="mt-9" data-id="element-69" data-mp="1ziavegctd3m7">
          <CtaButton href={CHECKOUT_URL} variant="gold" data-id="element-70" data-mp="1zgzrmgjdbvv3">
            Sí, quiero el Wedding Pro OS
          </CtaButton>
        </div>

        <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.14em] text-ivory/50" data-id="element-71" data-mp="24ifaq31zjsau">
          <li className="inline-flex items-center gap-2" data-id="element-72" data-mp="3fvrksvoc975g">
            <LockIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-73" data-mp="3fydt4xj1zqoq" />
            Pago 100% seguro
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-74" data-mp="39g0w6qnfzelo">
            <ZapIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-75" data-mp="39hlr4hdo4zk2" />
            Acceso inmediato
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-76" data-mp="3ndphfzlf8nr9">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-77" data-mp="3ifnw180iwccm" />
            Garantía de 7 días
          </li>
        </ul>
      </div>
    </section>;
}